var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasklistLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 510,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 727,
    y: 105,
    width: 509,
    height: 510
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-727 -105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.948 74.2292 387.052 74.2292 387.052 434.771 121.948 434.771 121.948 74.2292ZM90.1354 466.583 418.865 466.583 418.865 42.4167 90.1354 42.4167 90.1354 466.583Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.062 106.042 201.479 106.042 201.479 148.458 159.062 148.458Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.896 116.646 349.938 116.646 349.938 137.854 243.896 137.854Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.062 190.875 201.479 190.875 201.479 233.292 159.062 233.292Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.896 201.479 349.938 201.479 349.938 222.688 243.896 222.688Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.062 275.708 201.479 275.708 201.479 318.125 159.062 318.125Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.896 286.312 349.938 286.312 349.938 307.521 243.896 307.521Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.062 360.542 201.479 360.542 201.479 402.958 159.062 402.958Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.896 371.146 349.938 371.146 349.938 392.354 243.896 392.354Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00196 727 105)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasklistLight);
export default __webpack_public_path__ + "static/media/tasklist_light.70d40bb51ad30c6a09ace1d70cae4fab.svg";
export { ForwardRef as ReactComponent };